(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_quantity-breaks-item"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__qbSplitSelectsBound) return;
    window.__qbSplitSelectsBound = true;

    function readRow(row) {
      var values = [];
      row.querySelectorAll('[data-qb-option-select]').forEach(function (select) {
        values.push(select.value);
      });
      return values;
    }

    function findOption(hidden, key) {
      for (var i = 0; i < hidden.options.length; i++) {
        if (hidden.options[i].getAttribute('data-qb-options') === key) return i;
      }
      return -1;
    }

    function resyncFromHidden(row, hidden) {
      var current = hidden.options[hidden.selectedIndex];
      if (!current) return;
      var values = (current.getAttribute('data-qb-options') || '').split('||');
      row.querySelectorAll('[data-qb-option-select]').forEach(function (select, index) {
        if (values[index] !== undefined) select.value = values[index];
      });
    }

    // ---- Stock labelling -------------------------------------------------
    // Config lives on the parent <quantity-breaks> so one section-level set of
    // settings drives every offer row.
    function config(row) {
      var host = row.closest('quantity-breaks');
      var d = host ? host.dataset : {};
      // position: 'both' | 'list' (option labels only) | 'line' (status line only)
      var pos = d.stockPosition || 'both';
      return {
        on: d.stockEnabled === '1',
        inList: pos === 'both' || pos === 'list',
        line: pos === 'both' || pos === 'line',
        threshold: parseInt(d.stockThreshold, 10) || 0,
        out: d.stockOutText || '',
        low: d.stockLowText || '',
        lowOne: d.stockLowOneText || '',
        // An emptied separator must stay empty, so test for absence, not falsiness.
        // Ordinary spaces collapse inside an <option>; non-breaking ones survive.
        sep: (d.stockSep == null ? ' - ' : d.stockSep).replace(/ /g, ' '),
        gap: ' '.repeat(parseInt(d.stockGap, 10) || 0)
      };
    }

    // Look up the hidden <option> for the combination obtained by swapping the
    // value at `index` for `candidate`, leaving the other selects untouched.
    function optionFor(row, hidden, index, candidate) {
      var values = [];
      row.querySelectorAll('[data-qb-option-select]').forEach(function (s, i) {
        values.push(i === index ? candidate : s.value);
      });
      return hidden.options[findOption(hidden, values.join('||'))] || null;
    }

    // 'out' when unavailable or tracked at zero, 'low' under the threshold,
    // otherwise null. Untracked inventory never produces a claim.
    function stateOf(option, cfg) {
      if (!option) return null;
      var tracked = option.getAttribute('data-tracked') === '1';
      var avail = option.getAttribute('data-avail') === '1';
      var inv = parseInt(option.getAttribute('data-inv'), 10);
      if (!avail || (tracked && inv <= 0)) return { state: 'out', n: 0 };
      if (tracked && cfg.threshold > 0 && inv > 0 && inv <= cfg.threshold) {
        return { state: 'low', n: inv };
      }
      return null;
    }

    function labelFor(st, cfg) {
      if (!st) return '';
      if (st.state === 'out') return cfg.out;
      var tpl = st.n === 1 && cfg.lowOne ? cfg.lowOne : cfg.low;
      return tpl.replace(/\{n\}/g, st.n);
    }

    function relabel(row) {
      var cfg = config(row);
      var hidden = row.querySelector('[data-ref="quantity-break-variant-picker"]');
      if (!hidden) return;

      row.querySelectorAll('[data-qb-option-select]').forEach(function (sel, index) {
        for (var i = 0; i < sel.options.length; i++) {
          var opt = sel.options[i];
          var base = opt.getAttribute('data-base');
          if (base === null) {
            base = opt.textContent.trim();
            opt.setAttribute('data-base', base);
          }
          if (!cfg.on || !cfg.inList) { opt.textContent = base; continue; }
          var text = labelFor(stateOf(optionFor(row, hidden, index, opt.value), cfg), cfg);
          opt.textContent = text ? base + cfg.gap + cfg.sep + text : base;
        }
      });

      var line = row.querySelector('[data-qb-stock]');
      if (!line) return;
      var current = hidden.options[hidden.selectedIndex];
      var st = cfg.on && cfg.line ? stateOf(current, cfg) : null;
      if (!st) {
        line.hidden = true;
        line.removeAttribute('data-state');
        line.textContent = '';
      } else {
        line.hidden = false;
        line.setAttribute('data-state', st.state);
        line.textContent = labelFor(st, cfg);
      }
    }

    function relabelAll() {
      document.querySelectorAll('[data-qb-row]').forEach(relabel);
    }

    // Push a row's visible choices into its hidden picker, then repaint labels.
    function applyRow(row) {
      var hidden = row.querySelector('[data-ref="quantity-break-variant-picker"]');
      if (!hidden) return;

      var index = findOption(hidden, readRow(row).join('||'));

      if (index === -1) {
        resyncFromHidden(row, hidden);
        relabel(row);
        return;
      }

      if (hidden.selectedIndex !== index) {
        hidden.selectedIndex = index;
        hidden.dispatchEvent(new Event('change', { bubbles: true }));
      }
      relabel(row);
    }

    function syncsIndex(mode, index) {
      if (mode === 'all') return true;
      if (mode === 'option1') return index === 0;
      if (mode === 'option2') return index === 1;
      return false;
    }

    // The first row of an offer can drive the others. Assigning .value from
    // script fires no change event, so this cannot loop back into the handler.
    function propagate(sourceRow, changedIndex) {
      var host = sourceRow.closest('quantity-breaks');
      var mode = host ? host.dataset.rowSync : '';
      if (!mode || mode === 'none') return;
      if (!syncsIndex(mode, changedIndex)) return;

      var offer = sourceRow.closest('quantity-break-item');
      if (!offer) return;

      var rows = [].slice.call(offer.querySelectorAll('[data-qb-row]'));
      if (rows.length < 2 || rows[0] !== sourceRow) return;

      var source = sourceRow.querySelectorAll('[data-qb-option-select]')[changedIndex];
      if (!source) return;
      var value = source.value;

      rows.slice(1).forEach(function (row) {
        var target = row.querySelectorAll('[data-qb-option-select]')[changedIndex];
        if (!target || target.value === value) return;
        var exists = false;
        for (var i = 0; i < target.options.length; i++) {
          if (target.options[i].value === value) { exists = true; break; }
        }
        if (!exists) return;
        target.value = value;
        applyRow(row);
      });
    }

    document.addEventListener('change', function (event) {
      var select = event.target;
      if (!select || !select.hasAttribute || !select.hasAttribute('data-qb-option-select')) return;

      var row = select.closest('[data-qb-row]');
      if (!row) return;

      applyRow(row);
      propagate(row, parseInt(select.dataset.optionIndex, 10) || 0);
    });

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', relabelAll);
    } else {
      relabelAll();
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
